import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomepageComponent } from './components/core/home/homepage/homepage.component';
import { LoginComponent } from './components/Authentication/login/login.component';
import { ChangePasswordComponent } from './components/Authentication/change-password/change-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResigteringComponent } from './components/Authentication/resigtering/resigtering.component';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { HeaderComponent } from './shared/header/header.component';
import { HeaderMobileComponent } from './shared/header.mobile/header.mobile.component';
import { FooterComponent } from './shared/footer/footer.component';
import { VerificationCodeComponent } from './components/Authentication/verification-code/verification-code.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { LanguageServiceService } from './services/language-service.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeAr from '@angular/common/locales/ar-AE';
import { LoadingComponent } from './shared/loading/loading.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NodataComponent } from './shared/nodata/nodata.component';
import { ForgetPasswordComponent } from './components/Authentication/forget-password/forget-password.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// or
import { MatTableModule } from '@angular/material/table';
import { WelcomeComponent } from './components/core/static pages/welcome/welcome.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ServiceWorkerModule } from '@angular/service-worker';
import { ContactUsComponent } from './components/core/static pages/contact-us/contact-us.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

import { LazyLoadImageModule } from 'ng-lazyload-image';

import { GoogleMapsModule } from '@angular/google-maps';



import { NointernetComponent } from './components/core/static pages/nointernet/nointernet.component';
import { SafeUrlPipe } from './safe-url.pipe';
// import { registerLocaleData } from '@angular/common';
import { provideTransloco, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoModule } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './services/translocohttploader';

import { AtwComponent } from './components/core/home/atw/atw.component';
import { AtwCvUploaderComponent } from './components/core/home/atw-cv-uploader/atw-cv-uploader.component';
import { JobsinhomeComponent } from './components/core/jobs/jobsinhome/jobsinhome.component';
import { CreateJobComponent } from './components/core/jobs/create-job/create-job.component';
import { JobsfullpageComponent } from './components/core/jobs/jobsfullpage/jobsfullpage.component';
import { JobsdetailsComponent } from './components/core/jobs/jobsdetails/jobsdetails.component';
import { ApplypageComponent } from './components/core/jobs/applypage/applypage.component';
import { ApplyfordoctorComponent } from './components/core/jobs/applyfordoctor/applyfordoctor.component';
import { ApplyfordentistComponent } from './components/core/jobs/applyfordentist/applyfordentist.component';
import { ForcompanyComponent } from './components/core/home/forcompany/forcompany.component';
import { StatisticsComponent } from './components/core/home/statistics/statistics.component';
import { WhyusComponent } from './components/core/home/whyus/whyus.component';
import { OurpartnersComponent } from './components/core/home/ourpartners/ourpartners.component';
import { BlogsComponent } from './components/core/home/blogs/blogs.component';
import { AllreviewsComponent } from './components/core/home/allreviews/allreviews.component';
import { BlogsfullpageComponent } from './components/core/blogs/blogsfullpage/blogsfullpage.component';
import { BlogdetailsComponent } from './components/core/blogs/blogdetails/blogdetails.component';
import { FaqsComponent } from './components/core/faqs/faqs/faqs.component';
import { PoliciesComponent } from './components/core/policies/policies/policies.component';
import { TermsandcondComponent } from './components/core/policies/termsandcond/termsandcond.component';
import { CreatecompanyComponent } from './components/core/iamhiring/createcompany/createcompany.component';
import { AboutUsComponent } from './components/core/static pages/about-us/about-us.component';
import { SmartsearchComponent } from './components/core/jobs/smartsearch/smartsearch.component';
import { OurservicesComponent } from './components/core/static pages/ourservices/ourservices.component';
import { ChatComponent } from './components/core/chat/chat.component';
import { AddreviewComponent } from './components/core/profile/addreview/addreview.component';
import { MyprofileComponent } from './components/core/profile/myprofile/myprofile.component';
import { MyappliesComponent } from './components/core/profile/myapplies/myapplies.component';
import { MyjobsComponent } from './components/core/profile/myjobs/myjobs.component';
import { MychatticketsComponent } from './components/core/profile/mychattickets/mychattickets.component';
import { MyprofilecompanyComponent } from './components/core/profile/myprofilecompany/myprofilecompany.component';
import { UploadCVComponent } from './components/core/home/upload-cv/upload-cv.component';
import { ApplyanyComponent } from './components/core/home/applyany/applyany.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// registerLocaleData(localeAr);
@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    LoginComponent,
    ChangePasswordComponent,
    ResigteringComponent,
    HeaderComponent,
    FooterComponent,
    HeaderMobileComponent,
    VerificationCodeComponent,
    LoadingComponent,
    WelcomeComponent,
      NodataComponent,
    ForgetPasswordComponent,
    ContactUsComponent,
    NointernetComponent,
    SafeUrlPipe,
    AtwComponent,
    AtwCvUploaderComponent,
    JobsinhomeComponent,
    CreateJobComponent,
    JobsfullpageComponent,
    JobsdetailsComponent,
    ApplypageComponent,
    ApplyfordoctorComponent,
    ApplyfordentistComponent,
    ForcompanyComponent,
    StatisticsComponent,
    WhyusComponent,
    OurpartnersComponent,
    BlogsComponent,
    AllreviewsComponent,
    BlogsfullpageComponent,
    BlogdetailsComponent,
    FaqsComponent,
    PoliciesComponent,
    TermsandcondComponent,
    CreatecompanyComponent,
    AboutUsComponent,
    SmartsearchComponent,
    OurservicesComponent,
    ChatComponent,
    AddreviewComponent,
    MyprofileComponent,
    MyappliesComponent,
    MyjobsComponent,
    MychatticketsComponent,
    MyprofilecompanyComponent,
    UploadCVComponent,
    ApplyanyComponent

  ],
  imports: [
    BrowserModule,
    MatPaginatorModule,
    LazyLoadImageModule,
    AppRoutingModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    ZXingScannerModule,
    GoogleMapsModule,
    TranslocoModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-US',
    },
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideTransloco({
      config: {
        availableLangs: ['en', 'ar'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideClientHydration(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
